import { ResourceCategory } from './../builders/resource_category_builder';
import { IResourceCategoriesDatasource } from './../datasources/resource_categories_datasource';
import { IQuery, IQueryMediator, key } from 'core-ts-types';

export class ResourceCategoriesAlphabeticalQuery implements IQuery {
  private _result: ResourceCategory[];

  constructor(QueryMediator: IQueryMediator, private ngResourceCategoriesDatasource: IResourceCategoriesDatasource) {
    QueryMediator.registerQuery(this, ngResourceCategoriesDatasource);
  }

  run() {
    this._result = _<Record<string, ResourceCategory>>(this.ngResourceCategoriesDatasource.read())
      .sortBy<ResourceCategory>('ordering')
      .sortBy('name')
      .value();

    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-resources').service('ngResourceCategoriesAlphabeticalQuery', ResourceCategoriesAlphabeticalQuery);



// WEBPACK FOOTER //
// ./app/lib/resources/queries/resource_categories_alphabetical_query.ts